import request from '@/utils/request'


// 查询企业登记 -基本信息详细
export function getQydjJbxx(pripid) {
  return request({
    url: '/web/fdw/getQydjJbxxInfo/' + pripid,
    method: 'get'
  })
}
// 查询企业登记 -人员信息列表
export function listQydjRyxx(query) {
  return request({
    url: '/web/fdw/listQydjRyxx',
    method: 'get',
    params: query
  })
}
// 查询企业登记 -出资信息列表
export function listQydjCzxx(query) {
  return request({
    url: '/web/fdw/listQydjCzxx',
    method: 'get',
    params: query
  })
}
// 查询企业登记 -变更备案列表
export function listQydjBgsx(query) {
  return request({
    url: '/web/fdw/listQydjBgsx',
    method: 'get',
    params: query
  })
}

// 查询企业登记 -企业登记联络人详细
export function getQydjllrxxInfo(pripid) {
  return request({
    url: '/web/fdw/getQydjllrxxInfo/' + pripid,
    method: 'get'
  })
}
// 查询企业登记 -企业登记财务负责人人详细
export function getQydjCwfzrxxInfo(pripid) {
  return request({
    url: '/web/fdw/getQydjCwfzrxxInfo/' + pripid,
    method: 'get'
  })
}
// 查询年报-企业-基本信息列表
export function listNbQyJbxx(query) {
  return request({
    url: '/web/fdw/listNbQyJbxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-出资息列表
export function listNbQyCzxx(query) {
  return request({
    url: '/web/fdw/listNbQyCzxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-股权变更信息列表
export function listNbQyGqbgxx(query) {
  return request({
    url: '/web/fdw/listNbQyGqbgxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-对外投资信息列表
export function listNbQyDwtzxx(query) {
  return request({
    url: '/web/fdw/listNbQyDwtzxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-对外担保信息列表
export function listNbQyDwdbxx(query) {
  return request({
    url: '/web/fdw/listNbQyDwdbxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-网站网店信息列表
export function listNbQyWzwdxx(query) {
  return request({
    url: '/web/fdw/listNbQyWzwdxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-党建信息列表
export function listNbQyDjxx(query) {
  return request({
    url: '/web/fdw/listNbQyDjxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-社保信息列表
export function listNbQySbxx(query) {
  return request({
    url: '/web/fdw/listNbQySbxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-资产状况信息列表
export function listNbQyZczkxx(query) {
  return request({
    url: '/web/fdw/listNbQyZczkxx',
    method: 'get',
    params: query
  })
}
// 查询年报-企业-许可信息列表
export function listQyXkxx(query) {
  return request({
    url: '/web/fdw/listQyXkxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-食品生产企业检查信息，包含生产、流通、餐饮三个表
export function listSpscJcxx(query) {
  return request({
    url: '/web/fdw/listSpscJcxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-食药监管数据-药品检查项目信息列表
export function listYpjcxxx(query) {
  return request({
    url: '/web/fdw/listYpjcxxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-食药监管数据-药品抽检信息
export function listYpcjxxx(query) {
  return request({
    url: '/web/fdw/listYpcjxxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-食药监管数据-获取药品抽检信息详情
export function getYpcyInfo(xmsjlyid) {
  return request({
    url: '/web/fdw/getYpcyInfo/' + xmsjlyid,
    method: 'get'
  })
}
// 查询企业-监管信息-食药监管数据-食品抽检信息
export function listSpcjxx(query) {
  return request({
    url: '/web/fdw/listSpcjxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-食药监管数据-获取食品抽检信息详情
export function getSpcjxxInfo(dataclouduuid) {
  return request({
    url: '/web/fdw/getSpcjxxInfo/' + dataclouduuid,
    method: 'get'
  })
}
// 查询企业-监管信息-质检检验检测信息
export function listZjjcxx(query) {
  return request({
    url: '/web/fdw/listZjjcxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-特种设备基本信息
export function listTzsbJbxx(query) {
  return request({
    url: '/web/fdw/listTzsbJbxx',
    method: 'get',
    params: query
  })
}
// 查询企业-监管信息-双随机检查信息
export function listSsjJcxx(query) {
  return request({
    url: '/web/fdw/listSsjJcxx',
    method: 'get',
    params: query
  })
}
// 查询异常名录信息
export function listYcmlxx(query) {
  return request({
    url: '/web/fdw/listYcmlxx',
    method: 'get',
    params: query
  })
}
// 查询严重违法企业信息
export function listYzwfxx(query) {
  return request({
    url: '/web/fdw/listYzwfxx',
    method: 'get',
    params: query
  })
}
// 查询个体登记 -基本信息详细
export function getGtdjJbxxInfo(pripid) {
  return request({
    url: '/web/fdw/getGtdjJbxxInfo/' + pripid,
    method: 'get'
  })
}
// 查询个体登记 -经营者信息详细
export function getGtdjJyzxxInfo(pripid) {
  return request({
    url: '/web/fdw/getGtdjJyzxxInfo/' + pripid,
    method: 'get'
  })
}
// 查询个体登记-变更信息列表
export function listGtdjBgsx(query) {
  return request({
    url: '/web/fdw/listGtdjBgsx',
    method: 'get',
    params: query
  })
}
// 查询个体登记-许可信息列表
export function listGtdjXkxx(query) {
  return request({
    url: '/web/fdw/listGtdjXkxx',
    method: 'get',
    params: query
  })
}
// 查询个体年报-基本信息列表
export function listGtnbJbxx(query) {
  return request({
    url: '/web/fdw/listGtnbJbxx',
    method: 'get',
    params: query
  })
}
// 查询个体年报-党建信息列表
export function listGtnbDjxx(query) {
  return request({
    url: '/web/fdw/listGtnbDjxx',
    method: 'get',
    params: query
  })
}
// 查询个体年报-网站网店信息列表
export function listGtnbWdxx(query) {
  return request({
    url: '/web/fdw/listGtnbWdxx',
    method: 'get',
    params: query
  })
}
// 查询个体年报-许可信息列表
export function listGtnbXkxx(query) {
  return request({
    url: '/web/fdw/listGtnbXkxx',
    method: 'get',
    params: query
  })
}
// 查询个体年报-资产状况列表
export function listGtnbZczkxx(query) {
  return request({
    url: '/web/fdw/listGtnbZczkxx',
    method: 'get',
    params: query
  })
}